import React from 'react'
import { makeStyles, Skeleton } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  actionRow: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  actionBtn: {
    flex: 1,
    borderRadius: theme.borderRadius.md
  }
}))

export default function PainterScheduleShim() {
  const classes = useStyles()

  const CardShim = () => (
    <div className={classes.card}>
      <Skeleton width="60%" height="22px" />
      <Skeleton width="40%" height="16px" style={{ marginTop: 4 }} />
      <div className={classes.actionRow}>
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className={classes.actionBtn} height="40px" />
        ))}
      </div>
    </div>
  )
  return (
    <>
      <CardShim />
      <CardShim />
      <CardShim />
    </>
  )
}
